import amplitude from 'amplitude-js';

const apiKey = process.env.API_KEY_AMPLITUDE;

export const amplitudeInit = (props) => {
  amplitude.getInstance().init(apiKey, props);
};
export const amplitudeEvent = (name, props = {}) => {
  amplitude.getInstance().logEvent(name, { source_app: 'Ajaib Stock', ...props });
};
export const amplitudeSetUserId = (props) => {
  amplitude.getInstance().setUserId(props);
};
export const amplitudeRegenerateDeviceId = () => {
  amplitude.getInstance().regenerateDeviceId();
};